export const GET_LOGISTIC_LIST = "GET_LOGISTIC_LIST"
export const SET_LOGISTIC_LIST = "SET_LOGISTIC_LIST"

export function dispatchLogistic(param){
    return {
      type: param.type,
      payload: param.payload,
    };
  }